import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesforceMessagingService {

  private scriptLoaded = false;
  private bottonLoaded = new BehaviorSubject<boolean>(false)

  /**
   * Loads and initializes the Salesforce Embedded Messaging script.
   *
   * This method dynamically creates and appends a `<script>` element to load the Salesforce
   * Embedded Messaging bootstrap file. Once the script is successfully loaded, it sets
   * the `scriptLoaded` flag to `true` and calls `initializeEmbeddedMessaging()` to complete
   * the setup process. If the script is already loaded, the method exits early.
   */
  initMessaging(): void {
    if (this.scriptLoaded) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `${environment.salesforce.guest.baseURL}/assets/js/bootstrap.min.js`;
    script.onload = () => {
      this.scriptLoaded = true;
      this.initializeEmbeddedMessaging();
    };
    document.body.appendChild(script);
  }

  /**
   * Initializes the Salesforce Embedded Messaging service with the configured environment settings.
   *
   * This method sets the language for the embedded service and calls the Salesforce
   * `embeddedservice_bootstrap.init` function to start the messaging client. If the initialization
   * fails, an error will be logged to the console.
   *
   * @private
   * @throws Will log an error message to the console if initialization fails.
   */
  private initializeEmbeddedMessaging():void {
    try {
      // @ts-ignore
      embeddedservice_bootstrap.settings.language = 'es_MX';
      // @ts-ignore
      embeddedservice_bootstrap.init(
        environment.salesforce.orgId,
        environment.salesforce.guest.deploymentName,
        environment.salesforce.guest.baseURL,
        { scrt2URL: environment.salesforce.scrt2URL }
      );
      console.log('Salesforce Messaging inicializado correctamente');
      this.bottonLoaded.next(true);
    } catch (err) {
      console.error('Error loading Embedded Messaging: ', err);
      this.bottonLoaded.next(false);
    }
  }

  getButtonLoadedSubject() {
    return this.bottonLoaded.asObservable();
  }
}
